import { gql } from "lib/apolloClient";

const assessmentFragment = gql`
  fragment assessmentItem on Assessment {
    id
    type
    isImported
    title {
      id
      value
    }
    isImported
    academicTerm {
      id
      lockingStatus
    }
    assessmentType {
      id
      value
    }
    taskType {
      id
      type
      label
      color
      displaySequence
    }
    image {
      id
      value
    }
    category {
      id
      label
    }
    taggedPractices {
      evaluationCycle {
        id
      }
      taggedPractice {
        taggedBy {
          id
        }
        practice {
          id
        }
        evidenceStatus
      }
    }
  }
`;

const attachmentFragment = gql`
  fragment attachmentItem on Attachment {
    id
    attachmentType: type
    attachmentTitle: title
    name
    mimeType
    url
    signedUrl
    thumbUrl
    __typename
  }
`;

export const unitFlowItemFragment = gql`
  fragment unitFlowItem on EntityFlowResource {
    id
    label
    displaySequence
    isRepeated
    repeatedResources
    resourceType: itemType
    item {
      ... on Assessment {
        ...assessmentItem
      }
      ... on Attachment {
        ...attachmentItem
      }
      ... on EntityFlowResource {
        id
        attachment {
          ...attachmentItem
        }
      }
    }
    parent {
      id
    }
  }
  ${assessmentFragment}
  ${attachmentFragment}
`;
